import { render, staticRenderFns } from "./AppSelectorMulti.vue?vue&type=template&id=66a3bcb7&scoped=true&"
import script from "./AppSelectorMulti.vue?vue&type=script&lang=ts&"
export * from "./AppSelectorMulti.vue?vue&type=script&lang=ts&"
import style0 from "./AppSelectorMulti.vue?vue&type=style&index=0&id=66a3bcb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a3bcb7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VChip,VImg,VListItemContent})
